<h3 style="text-align: center">User successfully created.</h3>
<p style="text-align: center">On provided email address you will now receive mail with activation link.</p>

<div class="p-grid">
  <div class="p-col">
    <button pButton (click)="backToLogin()" label="Back to login" class="ui-button-secondary"></button>
  </div>
</div>
